import styled from 'styled-components';
import Modal from 'components/common/Modal';
import { buttonStyle, inputStyle } from 'lib/styles/index';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeviceInsertModalMacBox from './DeviceInsertModalMacBox';
import palette from 'lib/styles/palette';
import { changeProp, initialize } from 'modules/deviceSlice';
import { useMutation, useQueryClient } from 'react-query';
import { createDevice } from 'lib/api/device';
import useLoginCheck from 'hooks/common/useLoginCheck';
import NotiModal from 'components/common/NotiModal';

const DeviceInsertModal = ({ type, storeId, spaceId, onClose }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const [showMacBox, setShowMacBox] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const { id, name, macAddress, masterId, masterMacAddress } = useSelector(
    ({ device }) => device.device,
  );

  const createDeviceMutation = useMutation(createDevice, {
    onError: error => {
      if (error.response.statue === 500) {
        setShowErrorModal(true);
        onClose();
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries('device');
      onClose();
    },
  });
  useLoginCheck(createDeviceMutation.error?.response, () => {
    createDeviceMutation.mutate({
      id: storeId,
      device: {
        spaceId,
        deviceId: id,
        name,
        deviceType: type,
        masterId,
      },
    });
  });

  useEffect(() => {
    return () => {
      dispatch(initialize('device'));
    };
  }, [dispatch]);

  const onSubmit = () => {
    createDeviceMutation.mutate({
      id: storeId,
      device: {
        spaceId,
        deviceId: id,
        name,
        deviceType: type,
        masterId,
      },
    });
  };

  const onChange = e => {
    const { name, value } = e.target;
    dispatch(changeProp({ obj: 'device', key: name, value }));
  };

  return (
    <>
      {showErrorModal && (
        <NotiModal
          closeModal={() => setShowErrorModal(false)}
          msg="서버 오류로 등록이 실패했습니다"
          fontL
        />
      )}
      <Modal closeModal={onClose}>
        <DeviceInsertModalBlock>
          <div className="device-insert-modal-title">
            {type === '1' ? '온습도 센서 등록' : '컨트롤러 등록'}
          </div>
          <input
            type="text"
            placeholder="이름"
            name="name"
            value={name}
            onChange={onChange}
          />
          <div className="device-insert-modal-row">
            <input
              type="text"
              placeholder="Mac 주소"
              autoComplete="off"
              name="macAddress"
              value={macAddress}
              onChange={onChange}
              onFocus={() => setShowMacBox(true)}
            />
            {showMacBox && (
              <DeviceInsertModalMacBox
                type={type}
                macAddress={macAddress}
                setShowMacBox={setShowMacBox}
                storeId={storeId}
              />
            )}
          </div>
          <input
            type="text"
            placeholder="허브"
            disabled
            value={masterMacAddress}
          />
          <div className="device-insert-modal-btn-wrapper">
            <button onClick={onClose}>취소</button>
            <button onClick={onSubmit} disabled={!name || !masterMacAddress}>
              등록
            </button>
          </div>
        </DeviceInsertModalBlock>
      </Modal>
    </>
  );
};

export default DeviceInsertModal;

const DeviceInsertModalBlock = styled.div`
  height: 280px;
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;

  .device-insert-modal-title {
    font-weight: bold;
  }

  .device-insert-modal-row {
    position: relative;
  }

  input {
    ${inputStyle}
    width: 300px;
    margin-top: 1rem;
    &:disabled {
      background-color: rgba(0, 0, 0, 0.08);
    }
  }

  button {
    ${buttonStyle}
    padding: 5px 10px;
    font-size: 12px;
    &:disabled {
      background: ${palette.gray[4]};
    }
  }

  button + button {
    margin-left: 10px;
  }

  .device-insert-modal-btn-wrapper {
    margin-top: 1rem;
  }
`;
